import { createUseStyles } from 'react-jss';

export default createUseStyles({
  tabsPanel: {
    height: '50px',
    display: 'flex',
    justifySelf: 'end',
    '@media(max-width: 900px)': {
      flexDirection: 'column',
    }
  },

  linkWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '8px 25px',
    backgroundColor: 'white',

    fontSize: '14px',
    textAlign: 'center',
    color: ['#647276'],

    '&:first-child': {
      borderTopLeftRadius: '12px',
      borderBottomLeftRadius: '12px',
    },

    '&:last-child': {
      borderTopRightRadius: '12px',
      borderBottomRightRadius: '12px',
    },

    '&:hover': {
      textDecoration: 'none',
      color: 'white',
      backgroundColor: '#a79b95',
    },
    '@media(max-width: 900px)': {
      textAlign: 'left',
      top: 0,
      bottom: 0,
      zIndex: 100,
      paddingTop: '40px',
      paddingBottom: '40px',
      marginLeft: '-24px',
      '&:first-child': {
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
        borderTopRightRadius: '12px',
      },
      '&:last-child': {
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '12px',
      },
    }
  },

  active: {
    background: '#c4bfbc',
    color: ['white', '!important'],
    '&:hover': {
      textDecoration: 'none',
      color: 'white',
    },
  },
});
